import React from 'react';
import styles from '../LandingPage.module.css';
// import globeImg from '../../../images/globe-placeholder.png'; // Make sure to add an image or use an inline SVG

const HeroSection = () => {
  return (
    <div className={styles.heroSection}>
      <div className={styles.heroContainer}>
        <div className={styles.heroContent}>
          <div className={styles.pillDark}>✨ AI-Powered Global Capability Centers</div>
          <h1 className={styles.sectionTitleDark} style={{ fontSize: '3.5rem', lineHeight: 1.1, maxWidth: '600px' }}>
            From Talent to<br />
            Technology — <br />
            <span className={styles.gradientText}>Powering AI-Driven<br />GCCs</span>
          </h1>
          <p className={styles.sectionSubtitleDark} style={{ fontSize: '1.1rem', marginBottom: '2.5rem', maxWidth: '500px' }}>
            Provaantech helps global enterprises establish, operate and scale high-performance Global Capability Centers through an AI-first ecosystem of talent, platforms and engineering excellence.
          </p>
          <div className={styles.buttonGroup}>
            <a href="#explore" className={styles.heroPrimaryButton}>
              Explore the GCC BOT Model <span style={{ marginLeft: '8px', fontSize: '1.2em' }}>→</span>
            </a>
            <a href="#discover" className={styles.heroSecondaryButton}>
              Discover AI Capabilities
            </a>
          </div>
        </div>
        
        {/* Rectangular floating card for the globe */}
        <div className={styles.heroGlobeCard}>
          <div className={styles.heroGlobeInner}>
            {/* Placeholder for the India Globe graphic */}
            <div style={{ position: 'absolute', top: '20px', left: '20px', background: 'rgba(255,255,255,0.8)', padding: '4px 12px', borderRadius: '12px', fontSize: '0.75rem', color: '#0f172a', fontWeight: 600 }}>✨ India - GCC Hub</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
